

























































































import { Vue, Component } from 'vue-property-decorator';
import { namespace } from "vuex-class";
import AnnualReportDTO from "@/dto/archive/AnnualReportDTO";
import PaginationComponent from "@/components/util/PaginationComponent.vue";
import DocumentService from "@/services/DocumentService";
import { processError } from "@/utils/ComponentUtils";
import CreateAnnualReportModal from "@/components/documents/CreateAnnualReportModal.vue";
import PortalSelect from "@/components/common/PortalSelect.vue";
import SelectOption from "@/components/common/SelectOption";
import AnnualReportFilter from "@/dto/archive/AnnualReportFilter";
import PortalInput from "@/components/common/PortalInput.vue";
import { debounce } from "typescript-debounce-decorator";
import { STATE_LIST } from "@/constants/ProfileConstants";
import CompanyDTO from "@/dto/company/CompanyDTO";
import SimpleCompanySearch from "@/components/common/SimpleCompanySearch.vue";

const AppModule = namespace("App");

@Component<AnnualReportList>({
  components: { PortalInput, PortalSelect, PaginationComponent, SimpleCompanySearch },
  watch: {
    filter: {
      handler() {
        this.loadReports();
      },
      deep: true
    }
  }
})
export default class AnnualReportList extends Vue {

  @AppModule.Action private startLoading!: () => void;
  @AppModule.Action private stopLoading!: () => void;

  reports: Array<AnnualReportDTO> = [];
  totalPages = 1;
  private filter = new AnnualReportFilter();
  private types: Array<string> = [];
  private company: CompanyDTO | null = null;
  private year: number | null = null;

  mounted(): void {
    this.loadReports();
    this.loadTypes();
  }

  loadReports(): void {
    this.startLoading();
    DocumentService.getAnnualReports(this.filter).then(
      ok => {
        this.reports = ok.data.content;
        this.totalPages = ok.data.totalPages;
        this.stopLoading();
      },
      err => {
        this.stopLoading();
        processError(err, this);
      }
    )
  }

  loadTypes(): void {
    this.startLoading();
    DocumentService.getAnnualReportTypes().then(
      ok => {
        this.types = ok.data;
        this.stopLoading();
      },
      err => {
        this.stopLoading();
        processError(err, this);
      }
    )
  }

  changePage(page: number): void {
    this.filter.pageNumber = page;
  }

  newReport(): void {
    this.$modal.show(
      CreateAnnualReportModal,
      {
        onSaved: () => this.reset()
      }
    )
  }

  reset(): void {
    this.totalPages = 1;
    this.filter.pageNumber = 1;
    this.loadReports();
    this.loadTypes();
  }

  private selectCompany(): void {
    this.filter.companyId = this.company ? this.company.id : null;
  }

  @debounce(500)
  private changeYear() {
    this.filter.year = this.year;
  }

  private get buildTypesOptions(): Array<SelectOption> {
    return [
      ...this.types.map(item => SelectOption.builder().title(item).value(item).build()),
      SelectOption.builder().title('All types').value(null).build()
    ];
  }

  private get buildStatesOptions() {
    return STATE_LIST.map(state => SelectOption.builder().title(state).value(state).build());
  }
}
